import styled from '@emotion/styled';

export default styled.div`
  width: 350px;
`;
